'use strict';

var NewCalendarToolbarController = function NewCalendarToolbarController($scope) {
  $scope.closeNewCalendar = function () {
    $scope.visible = false;
  };
};
NewCalendarToolbarController.$inject = ['$scope'];
module.exports = NewCalendarToolbarController;